// extracted by css-extract-rspack-plugin
export default {"listItem":"SectionListItem-module__listItem__F7RhBge"};